import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// #region TYPES
const USER_PREFS_SET_TEMP = 'USER_PREFS_SET_TEMP';
const USER_PREFS_SET_ASSETFILTERS = 'USER_PREFS_SET_ASSETFILTERS';
const USER_PREFS_INITIALIZE = 'USER_PREFS_INITIALIZE';
const USER_PREFS_SET_PRESSURE = 'USER_PREFS_SET_PRESSURE';
const USER_PREFS_SET_DISTANCE = 'USER_PREFS_SET_DISTANCE';
// #endregion TYPES

const initState = {
  temp: localStorage.getItem('temperatureUnit') || 'Celsius',
  pressure: localStorage.getItem('pressureUnit') || 'Pa',
  distance: localStorage.getItem('distanceUnit') || 'Metric',
  assetFilters: [],
};

// Actions

export function userPrefsSetTempAction(temp) {
  return {
    type: USER_PREFS_SET_TEMP,
    temp,
  };
}

export function userPrefsSetPressureAction(pressure) {
  return { type: USER_PREFS_SET_PRESSURE, pressure };
}

export function userPrefsSetDistanceAction(distance) {
  return { type: USER_PREFS_SET_DISTANCE, distance };
}

export function userPrefsInitializeAction(temp, pressure, distance, assetFilters) {
  return {
    type: USER_PREFS_INITIALIZE,
    payload: { temp, pressure, distance, assetFilters },
  };
}

// Handlers

function handleSetTemp(state, { temp }) {
  localStorage.setItem('temperatureUnit', temp); // Save to localStorage
  return {
    ...state,
    temp,
  };
}

function handleSetPressure(state, { pressure }) {
  localStorage.setItem('pressureUnit', pressure);
  return { ...state, pressure };
}

function handleSetDistance(state, { distance }) {
  localStorage.setItem('distanceUnit', distance);
  return { ...state, distance };
}

// Extend initialize to include new prefs

function handleInitialize(state, { payload }) {
  return {
    ...state,
    temp: payload.temp,
    pressure: payload.pressure || state.pressure,
    distance: payload.distance || state.distance,
    assetFilters: payload.assetFilters || state.assetFilters,
  };
}

export function userPrefsSetAssetFiltersAction(assetFilters) {
  return {
    type: USER_PREFS_SET_ASSETFILTERS,
    assetFilters,
  };
}

function handleSetAssetFilters(state, { assetFilters }) {
  return {
    ...state,
    assetFilters,
  };
}

const actionHandler = {
  [USER_PREFS_SET_TEMP]: handleSetTemp,
  [USER_PREFS_SET_ASSETFILTERS]: handleSetAssetFilters,
  [USER_PREFS_INITIALIZE]: handleInitialize,
  [USER_PREFS_SET_PRESSURE]: handleSetPressure,
  [USER_PREFS_SET_DISTANCE]: handleSetDistance,
};

const reducer = (state = initState, action) => {
  const handlerFn = actionHandler[action.type];

  if (!handlerFn) return state;

  return handlerFn(state, action);
};

// Persist the userPrefs reducer
const persistConfig = {
  key: 'userPrefs',
  storage,
};

export default persistReducer(persistConfig, reducer);
